import { render, staticRenderFns } from "./alibind.vue?vue&type=template&id=6eec2380"
import script from "./alibind.vue?vue&type=script&lang=js"
export * from "./alibind.vue?vue&type=script&lang=js"
import style0 from "./alibind.vue?vue&type=style&index=0&id=6eec2380&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports